import React, { useState } from 'react';
import AppLogo from '../components/AppLogo';
import AppTitle from '../components/AppTitle';
import _ from 'lodash';
import PageLoader from '../components/PageLoader';
import Back from '../components/backComponent';
import '../App.css';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Auth from '../core/services/auth';
import { useNavigate } from 'react-router-dom';


function VendorLogin() {
    const navigate = useNavigate();
    const [ name, setName ] = useState('')
    const [ passwordError ] = useState('')
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = (event: any) => {
        
        event.preventDefault();
        
        // Set Loader
        setLoading(true)

        //  set form data
        const formData = {
            name: name,
        }
  
        Auth.vendorlogin(formData).then(res => {
          setLoading(false)

          console.log(res.data)

          //  setup vendor
          Auth.setVendor(res.data.data)
          
          setTimeout(()=>{
            // navigate 
            navigate('/vendor', { state: { name: name } })
          }, 1800)

          // toast.success(res.data.message, {
          //   position: "top-center",
          // });

        }).catch(err=>{
  
          console.log(err)
  
          setLoading(false)

          if (_.isArray(err.response.data.error)) {
            let error = err.response.data.error
            //
            for (let index = 0; index < error.length; index++) {
              const err = error[index];
              toast.error(err.message, {
                position: "top-center",
              });
            }
          } else {
            toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
              position: "top-center",
            });
          }
  
        })
    
    
      } 

    return (
        <div className='dark:bg-gray-800 dark:text-white'>
            
            <Back title='Account'/>
            <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto h-[80vh] md:h-screen lg:py-0">
                { loading ? <PageLoader /> : '' }
                <ToastContainer />
                <AppLogo />
                <AppTitle title={'Vendor Login'} description={'Discover places & events'} />

                <div className="w-full md:mt-0 sm:max-w-md xl:p-0 mt-5">
                <div className="p- space-y-4 md:space-y-6 sm:p-8">
                    {/* <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                        Sign in to your account
                    </h1> */}
                    <form className="space-y-4 md:space-y-5" onSubmit={handleSubmit}>
                        <div>
                            <input type="text" name="name" id="name" placeholder="Name" className="bg-gray-50 text-gray-900 rounded-lg focus:ring-grey-600 focus:border-grey-600 block w-full py-4 px-5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" onChange={ (e) => setName(e.target.value) }  value={name}  required={true}/>
                            <label className='text-left'>{passwordError}</label>
                        </div>
                        <div className='flex flex-col space-y-4 '>
                            <button type="submit" className="w-full rounded-full text-white bg-yellow-800 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium text-sm px-5 py-4 text-center dark:bg-yellow-600 dark:hover:bg-yellow-700 dark:focus:ring-yellow-800">Continue</button>
                            
                        </div>
                    </form>
                    <div className='py-10'>

                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}

export default VendorLogin